import React from 'react';

export default React.createContext({
  disabled: false,
});
